import { NgModule } from '@angular/core';
import { AccountableItemComponent } from "app/pages/accountable/components/accountable-item/item";
import { NgIf } from "@angular/common";
import { IconComponentModule } from "app/components/ui/icon/item.module";

@NgModule({
  imports: [
    NgIf,
    IconComponentModule
  ],
  exports: [
    AccountableItemComponent
  ],
  declarations: [AccountableItemComponent],
  providers: [],
})
export class AccountableItemComponentModule {
}
